import moment from 'moment-timezone';
const second = 1000;
const minute = 60 * second;
const hour = 60 * minute;
/**
 * Returns an interval based on the time difference between now and the given
 * time
 */
export function getIntervalBasedOnTimeDifference(dateTime) {
    var _a;
    const diff = Math.abs((_a = dateTime === null || dateTime === void 0 ? void 0 : dateTime.diff(moment())) !== null && _a !== void 0 ? _a : 0);
    if (!dateTime || diff > 2 * hour) {
        return hour;
    }
    if (diff > 2 * minute) {
        return minute;
    }
    return second;
}
